import { Box, List, Text } from '@shopify/polaris';
import { VerticalSpace } from '../Reports/VerticalSpace';
import { useEffect, useState } from 'react';
import useSells from '../../../customHooks/useSells';

const NotSoldDays = ({ refresh }) => {
  const { getNoSoldDays } = useSells();
  const [notSoldDays, setNotSoldDays] = useState([]);

  const findNotSoldDays = () => {
    const yesterday = new Date();
    yesterday.setDate(yesterday.getDate() - 1);
    const halfYearAgo = new Date();
    halfYearAgo.setDate(halfYearAgo.getDate() - 365);
    getNoSoldDays({
      since: halfYearAgo,
      until: yesterday,
    }).then(setNotSoldDays);
  };

  useEffect(() => {
    findNotSoldDays();
    // eslint-disable-next-line
  }, [refresh]);

  return (
    notSoldDays.length !== 0 && (
      <>
        <VerticalSpace />
        <Box borderColor="border" borderWidth={1} borderRadius={2} padding={5} margin={5}>
          <Text variant="headingMd" as="h4">
            Días sin ventas registradas
          </Text>
          <VerticalSpace />
          <List type="bullet">
            {notSoldDays.map((day, index) => (
              <List.Item key={index}>
                {Intl.DateTimeFormat('es-ES', {
                  weekday: 'long',
                  year: 'numeric',
                  month: 'long',
                  day: 'numeric',
                }).format(new Date(day))}
              </List.Item>
            ))}
          </List>
        </Box>
      </>
    )
  );
};

export default NotSoldDays;
